import React from 'react';
import { Coins } from 'lucide-react';

const Footer: React.FC = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="relative z-10 border-t bg-black/40 backdrop-blur-sm" style={{ borderColor: '#3d3d3d' }}>
      {/* Mobile-only: 10 Free Credits badge (moved from header) */}
      <div className="md:hidden flex justify-center pt-6 pb-2">
        <div className="flex items-center gap-1.5 px-3 py-2 bg-red-900/30 rounded-full border-2 border-red-500/50 shadow-md shadow-red-500/20">
          <Coins size={14} className="text-red-400 shrink-0" />
          <span className="font-bold text-red-200 text-xs whitespace-nowrap">10 Free Credits</span>
        </div>
      </div>
      <div className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          <div>
            <div className="mb-3">
              <img src="/Planos Logo Red.png" alt="Planos.studio" className="h-10 w-auto object-contain object-left" />
            </div>
            <p className="text-xs text-slate-500 leading-relaxed">Overlay floor plans on Google Maps, add camera hotspots with real photos, and publish interactive spatial maps.</p>
          </div>
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider mb-3" style={{ color: '#FF3B30' }}>Product</h4>
            <ul className="space-y-2 text-xs text-slate-500">
              <li>Map Overlay Editor</li>
              <li>Camera Hotspots</li>
              <li>360° Pano Upload</li>
              <li>Interactive Viewer</li>
              <li>Publish & Share</li>
            </ul>
          </div>
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider mb-3" style={{ color: '#FF3B30' }}>Company</h4>
            <ul className="space-y-2 text-xs text-slate-500">
              <li><a href="https://hub.rehub.studio" target="_blank" rel="noopener noreferrer" className="hover:text-[#FF3B30] transition-colors">ReHub Studio</a></li>
              <li><a href="https://hub.rehub.studio/#/contact" className="hover:text-[#FF3B30] transition-colors">Contact</a></li>
              <li><a href="https://rehub.studio/terms" target="_blank" rel="noopener noreferrer" className="hover:text-[#FF3B30] transition-colors">Terms</a></li>
              <li><a href="https://rehub.studio/privacy" target="_blank" rel="noopener noreferrer" className="hover:text-[#FF3B30] transition-colors">Privacy</a></li>
            </ul>
          </div>
        </div>
        <div className="pt-6 border-t flex flex-col sm:flex-row items-center justify-between gap-3" style={{ borderColor: 'rgba(61,61,61,0.5)' }}>
          <p className="text-[11px] text-slate-600">&copy; {year} ReHub Studio. All rights reserved.</p>
          <span className="text-[11px] text-slate-600">Part of the ReHub Suite</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
